<template>
    <div class="tableContents">
        <div class="scrollWrapper vertical">
             <!-- <scrollbar :ops="scrollSettings"> -->
                <div class="tableContents__head">
                    <div class="tableContents__head--wrapper">
                        <div class="tableContents__head--contents">
                            <p class="name"><img src="@/assets/images/svg/logo.svg" alt="zain-logo"></p>
                            <p class="title">{{$t('reportmenu.title')}}</p>
                            <p class="date">2020</p>
                        </div>
                        <div class="extralinks">
                            <ul>
                                <li>
                                    <router-link :to="`/${$i18n.locale}/2020-at-glance`">{{$t('reportmenu.glancepagetitle')}}</router-link>
                                </li>
                                <li>
                                    <a :href="download_url()" target="_blank">
                                        <span class="pdf-icon">
                                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" width="35" height="35" xml:space="preserve">
                                                <g>
                                                    <path fill="currentColor" d="M62.79,451.4V119.87H23.28V451.4h-0.06v0c0,21.82,17.69,39.51,39.51,39.51h330.66V451.4H62.79z"></path>
                                                    <g>
                                                        <path fill="currentColor" d="M175.63,166.74c-6.21,0-10.41,0.6-12.61,1.2v39.82c2.61,0.6,5.81,0.8,10.21,0.8
                                                            c16.21,0,26.22-8.2,26.22-22.01C199.44,174.15,190.83,166.74,175.63,166.74z"></path>
                                                        <path fill="currentColor" d="M293.44,167.14c-6.81,0-11.21,0.6-13.81,1.2v88.25c2.6,0.6,6.8,0.6,10.6,0.6
                                                            c27.62,0.2,45.63-15.01,45.63-47.23C336.06,181.95,319.66,167.14,293.44,167.14z"></path>
                                                        <path fill="currentColor" d="M482.1,21.09H118.86c-3.69,0-6.68,2.99-6.68,6.68V391c0,3.69,2.99,6.68,6.68,6.68H482.1
                                                            c3.69,0,6.68-2.99,6.68-6.68V27.77C488.78,24.08,485.79,21.09,482.1,21.09z M217.25,217.78c-10.41,9.8-25.81,14.21-43.83,14.21
                                                            c-4,0-7.6-0.21-10.41-0.6v48.24H132.8V146.53c9.41-1.6,22.62-2.81,41.23-2.81c18.82,0,32.22,3.61,41.23,10.81
                                                            c8.6,6.8,14.41,18.01,14.41,31.22C229.66,198.96,225.26,210.17,217.25,217.78z M345.87,263.6c-14.2,11.81-35.82,17.42-62.23,17.42
                                                            c-15.81,0-27.02-1.01-34.62-2.01V146.53c11.21-1.81,25.81-2.81,41.22-2.81c25.62,0,42.23,4.6,55.23,14.41
                                                            c14.01,10.41,22.81,27.02,22.81,50.84C368.28,234.79,358.89,252.59,345.87,263.6z M470.68,169.75h-51.83v30.82h48.43v24.82h-48.43
                                                            v54.24h-30.62V144.73h82.44V169.75z"></path>
                                                    </g>
                                                </g>
                                            </svg>
                                        </span>
                                        {{$t('reportmenu.downloadReport')}}
                                        <span class="download-icon">
                                            <svg x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve" width="35" height="35">
                                                <g>
                                                    <polygon class="st0" fill="currentColor" points="447.69,193.53 340.28,193.53 340.28,20.35 180.49,20.35 180.49,193.53 64.31,193.53 260.5,383.69 	"></polygon>
                                                    <rect x="59.81" y="447.81" fill="currentColor" width="392.38" height="43.84"></rect>
                                                </g>
                                            </svg>
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="tableContents__head--menu">
                            <div class="menuWrapper">
                                <langSwitch></langSwitch>
                                <svg class="separator" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 13" width="6" height="13">
                                    <path fill="white" d="M3.93 0L6 0L2.07 13L0 13L3.93 0Z" />
                                </svg>
                                <div class="menu-icon">
                                    <a v-if="this.$route.name!='tablecontents'" href="#" @click.stop.prevent="menuAnimationClose" class="menu">
                                        <menuIcon></menuIcon>
                                    </a>
                                    <router-link v-if="this.$route.name=='tablecontents'" :to="`/${$i18n.locale}/`">
                                        <menuIcon></menuIcon>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tableContents__wrapper">
                    <div class="container-fluid">
                        <b-card no-body>
                            <b-tabs pills card vertical>
                                <b-tab v-for="menu in reportMenu" :key="menu.id" :active="selected_tab_name === menu.group_label">
                                     <template #title>
                                        <span v-if="$i18n.locale=='en'">{{menu.title}}</span>
                                        <span v-if="$i18n.locale=='ar'">{{menu.title_ar}}</span>
                                    </template>
                                    <b-card-text>
                                        <div class="scrollWrapper">
                                            <scrollbar :ops="scrollSettings">
                                                <div class="tableContents__sections--row">
                                                    <div class="tableContents__sections--section" v-for="mitem in menu.menuItems" :key="mitem.id">
                                                        <router-link :to="`/${$i18n.locale}/${mitem.url}`"  v-on:click.native="menuAnimationClose">
                                                            <div class="imageWrapper">
                                                                <div class="image">
                                                                    <img :src="require(`@/assets/images/menu/${mitem.image}`)" alt=""> 
                                                                    <p class="name" v-if="$i18n.locale=='en'">{{mitem.title}}</p>
                                                                    <p class="name" v-if="$i18n.locale=='ar'">{{mitem.title_ar}}</p>
                                                                </div>
                                                                
                                                            </div>
                                                        </router-link>
                                                    </div>
                                                </div>
                                            </scrollbar>
                                        </div>
                                    </b-card-text>
                                </b-tab>
                                
                            </b-tabs>
                        </b-card>
                    </div>
                </div>
        </div>
    </div>
</template>

<script>
import langSwitch from "@/common/layout/partials/languageSwitch.vue";
import menuIcon from "@/common/layout/partials/menuIcon.vue";
import util from '@/mixin/util.js';
import menu from '@/assets/data/menu.json';
import { gsap } from "gsap";
var tl = gsap.timeline({ paused: true });
    export default {
        components:{
            langSwitch,
            menuIcon
        },
        mixins: [util],
        data(){
            return{
                scrollSettings: {
                    maxHeight: 100
                },
                reportMenu: menu,
                selected_tab_name: "strategicreview"
            }
        },
        mounted(){
            this.selected_tab_name = this.$route.meta.parent;
        },
        methods:{
            
            toggleMenu: function(){
                this.menuAnimationOpen();
                document.body.classList.add("menuOpen");
                document.documentElement.classList.add("menuOpen");
            },
            menuAnimationOpen: function(){
                tl
                .to(".tableContents",{zIndex: 999, duration: 0.1})
                .to(".tableContents",{opacity: 1, zIndex: 999, duration: 0.9},"+=0.2")
                .to(".content-wrapper", {autoAlpha:0, opacity: 0, duration: 0.4, ease: "power1.in"}, "-=0.4")
                .to(".header", {autoAlpha: 0, opacity: 0, duration: 0.4, ease: "power1.in"}, "-=0.1")
                .play();
            },
            menuAnimationClose: function(){
                tl
                .to(".tableContents",{zIndex: -999, duration: 0.1})
                .to(".content-wrapper", {autoAlpha: 1, opacity: 1, duration: 0.5, ease: "power1.in"})
                .to(".header", {autoAlpha: 1, opacity: 1, duration: 0.4, ease: "power1.in"},"-=0.3")
                .to(".tableContents",{opacity: 0, duration: 0.7, ease: "power1.in"},"-=0.2")
                .play();
                 document.body.classList.remove("menuOpen");
                 document.documentElement.classList.remove("menuOpen");
            },
            isActiveMenu: function(parent){
                if(this.$route){
                    if(this.$route.meta.parent==parent){
                        return true;
                    }
                }
            },
            download_url: function(){
                return this.$i18n.locale === 'ar' ? 'https://d364xagvl9owmk.cloudfront.net/media-10-4-18/media/filer_public/21/6b/216b37bc-ce1d-4642-95ac-b4cd57b7a7ef/zain_annual_report_arabic__2020.pdf' : 'https://d364xagvl9owmk.cloudfront.net/media-10-4-18/media/filer_public/1b/f4/1bf44f50-9c49-4b6f-b46a-0b33adc36770/zain_annual_report_english__2020.pdf'
            }
        },
        watch: {
            $route() {
            }
        },
    }
</script>

<style lang="scss" scopped >
.tableContents{
    padding:rem(30px) 0;
    height: 100vh;
    position:fixed;
    opacity: 0;
    z-index: -999;
    width:100%;
    top: 0;
    overflow:hidden;
    &:after{
        position:absolute;
        content:"";
        width:100%;
        height:100%;
        background:url(../assets/images/banners/tableContent-banner.png) left top no-repeat;
        background-size: cover;
        left:0;
        top:0;
        z-index:-1;

    }
    .separator{
        width: 7px;
        margin: 0 23px 0 13px;
    }
    small{
        font-weight:700;
    }
    @media screen and (min-width:1025px) {
        background-attachment: fixed;
    }
    @media screen and (max-width:1600px){
        .scrollWrapper.vertical{
            height:700px;
        }
        padding:rem(16px) 0;
    }
    .scrollWrapper.horizontal{
        width:1650px;
        padding-right:200px;
        @media screen and (max-width:1600px){
            width:940px;
            padding-right:20px;
        }
        @media screen and (max-width:1199px) and (min-width:992px){
            width:600px;
        }
    }

    &:before{
        content:"";
        position:absolute;
        width:100%;
        height:100%;
        left:0;
        top:0;
        background:rgba($color: #000000, $alpha: .3);
    }
    .borderLayer{
        max-width:150px;
        flex:0 0 150px;
        width:150px;
        border-right:2px solid #707070;
        height:100%;
        position:fixed;
        top:0;

    }
    a{
        color:#fff;
        &:hover{
            opacity:.7;
        }
    }
    ul{
        list-style: none;
        padding:0;
        margin:0;
    }
    &__head{
        display:flex;
        padding-bottom:rem(50px);
        position:relative;
        z-index:2;
        .zain-logo{
            max-width:150px;
            flex:0 0 150px;
            text-align: center;

        }
        &--wrapper{
           @include flex(start , space-between);
            width:100%;
            padding-left:rem(50px);
            padding-right:rem(50px);
            .extralinks{
                flex: 0 0 33%;
                max-width: 33%;
                ul{
                    @include flex(center,space-between);
                    li{
                        @media screen and (max-width:767px){
                            font-size:rem(14px);
                        }
                    }
                    a{
                        font-weight: 900;
                        font-size: 17px;
                        text-transform: uppercase;
                        @media screen and (max-width:991px){
                            font-size:16px;
                        }
                        @media screen and (max-width:767px){
                            font-size:14px;
                        }
                        span{
                            display: inline-block;
                            svg{
                                max-width: 28px;
                                height: auto;
                            }
                            &.pdf-icon{
                                padding-right: rem(8px);
                            }
                            &.download-icon{
                                padding-left: rem(8px);
                            }
                            @media screen and (max-width:767px){
                                svg{
                                    max-width:20px;
                                }
                                &.pdf-icon{
                                    padding-right: rem(5px);
                                }
                                &.download-icon{
                                    padding-left: rem(5px);
                                }
                            }
                        }
                    }
                }
                @media screen and (max-width:1600px){
                    position:absolute;
                    left:50%;
                    transform:translateX(-50%);
                    max-width:100%;
                    flex:0 0 100%;
                    width:100%;
                    ul{
                        justify-content: center;
                        li{
                            &:not(:last-child){
                                margin-right:rem(25px);
                            }
                            a{
                                margin:0;
                            }
                        }
                    }
                }
                @media screen and (max-width:991px){
                    ul{
                        flex-direction:column;
                        a{
                            font-size:14px;
                        }
                        li{
                            &:not(:last-child){
                                margin:0 0 rem(20px) 0 !important;
                            }
                        }
                    }
                }
                @media screen and (max-width:575px){
                    top:75px;
                    ul{
                        li{
                            a{
                                font-size:13px;
                            }
                        }
                    }
                }
            }
        }
        &--contents{
            p{
                color:var(--white);
                font-size:rem(18px);
                font-weight:600;
                line-height:1;
                margin-bottom:0;
                &.title{
                    margin:7px 0;
                    font-weight:900;
                }
                &.date{
                    color:var(--yellow);
                    font-weight:900;
                }
                &.name{
                    img{
                        max-width:90px;
                    }
                }
            }
            @media screen and (max-width:767px){
                p{
                    font-size:rem(15px);
                }
            }
        }
        &--menu{
            @include flex(center , start);
            .back{
                color:var(--white);
                font-size:rem(18px);
                font-weight:600;
                margin-right:rem(30px);
                text-transform:uppercase;
                &:hover{
                    opacity:.7;
                }
            }
            
            
            // .menu{
            //     svg{
            //         width:40px;
            //         height:auto;
            //         fill:#fff;
            //     }
            //     &:hover{
            //         opacity:.7;
            //     }
            // }
        }
    }
    &__sections{
        &--row{
            display: flex;
            flex-wrap:wrap;
            padding-left:rem(50px);
            >div{
                margin-right:rem(75px);
                margin-bottom:rem(30px);
                
            }
            @media screen and (max-width:1600px){
                >div{
                    max-width:33%;
                    flex:0 0 33%;
                    margin-right:0;
                }
            }
            @media screen and (max-width:1199px){
                justify-content:center;
                >div{
                    max-width:50%;
                    flex:0 0 50%;
                }
            }
            @media screen and (max-width:991px){
                justify-content: start;
                width:100%;
                margin:0;
                padding:0;
                flex-direction:row;
                >div {
                    max-width:25%;
                    flex:0 0 25%;
                } 
            }
            @media screen and (max-width:767px){
                >div {
                    max-width:33.3%;
                    flex:0 0 33.3%;
                } 
            }
            @media screen and (max-width:575px){
                justify-content: center;
                padding-right:rem(32px);
                >div{
                    max-width:50%;
                    flex:0 0 50%;
                }
            }
        }
        &--section{
            .imageWrapper{
                .image{
                   width:250px;
                    height:150px;
                    position:relative;
                    transition:.5s ease all;
                    &:before{
                        content:"";
                        position:absolute;
                        width:100%;
                        height:100%;
                        background:rgba($color: #000000, $alpha: .4);
                    }
                    &:after{
                        content:"";
                        position:absolute;
                        width:0;
                        height:100%;
                        left:0;
                        top:0;
                        transition:.5s ease all;
                        background:rgba($color: #fff, $alpha: .4);
                    }
                }
                img{
                    width:100%;
                    height:100%;
                }
                
                .name{
                    position:absolute;
                    top:30%;
                    left:-40px;
                    max-width:275px;
                    // text-transform: uppercase;
                    font-size:rem(17px);
                    font-weight:900;
                    color:var(--white);
                    text-transform: uppercase;
                    white-space: pre-wrap;
                }
                &:hover{
                    .image{
                        &:after{
                            width:100%;
                            transition:.5s ease all;
                        }
                    }
                }
            }
            .router-link-active{
                .imageWrapper p.name{
                    color: var(--yellow);
                }
            }
        }
    }
    &__wrapper{
        // display: flex;
         position:relative;
        z-index:2;
        overflow-y: auto;
        padding:0 rem(30px);
        min-height: calc(100vh - 135px);
        .card{
            background:transparent;
            padding:0;
            width:100%;
            height:100%;
            margin:0;
            border:0;
            box-shadow:none;
            .tabs{
                .nav{
                    background: transparent;
                    position:relative;
                    // &:after{
                    //     content:"";
                    //     position:absolute;
                    //     height:300px;
                    //     width:2px;
                    //     right:-35px;
                    //     background:#707070;
                    //     top:50%;
                    //     transform: translateY(-50%);
                    // }
                    li{
                        padding:rem(100px) 0;
                        a{
                            font-size:rem(20px);
                            font-weight:900;
                            color:var(--white);
                            text-transform:uppercase;
                            padding:0;
                            background:transparent !important;
                            &:active , &.active , &:focus{
                                color:var(--yellow);

                            }
                            @media screen and (min-width:1025px){
                                &:hover{
                                    color:var(--yellow);
                                }
                            }
                        }
                    }
                }
            }
        }
        @media screen and (max-width:1600px){
            .card {
                .tabs {
                    .nav {
                        li{
                            padding:rem(60px) 0;
                        }
                    }
                }
            }
            .scrollWrapper{
                height: calc(100vh - 120px);
            }
        }
        @media screen and (max-width:1300px){
            .card{
                .card-body{
                    padding-left:rem(20px);
                }
            }
        }
        @media screen and (max-width:1199px){
            padding:0;
            .scrollWrapper{
                padding-bottom:rem(20px);
            }
        }
        @media screen and (max-width:992px) and (min-width:768px){
            padding:0 0 0 45px;
        }
        @media screen and (max-width:991px){

            .card{
                .nav{
                    flex-direction:row !important;
                    justify-content: space-between;
                    padding: 0 20px 0 0;
                }
                .tabs{
                    flex-direction:column;
                    .col{
                        max-width:100%;
                        flex:0 0 100%;
                        width:100%;
                    }
                }
                .card-body{
                    padding:0;
                }
                .tabs {
                    .nav{
                        li {
                            padding:20px 0;
                        }
                    }
                }
            }
            .scrollWrapper{
                height: calc(100vh - 180px);
                padding-bottom:0;
            }
        }
        @media screen and (max-width:767px){
            .card{
                .tabs{
                    .nav {
                        li{
                            a{
                                font-size:rem(16px);
                            }
                        }
                    }
                }
            }
        }
        @media screen and (max-width:575px){
            padding-top:rem(40px);
            .card{
                .tabs {
                    .nav {
                        padding-right:0;
                        padding-top:rem(30px);
                        li {
                            a{
                                font-size:13px;
                            }
                        }
                    }
                }
            }
            .scrollWrapper{
                height: calc(100vh - 300px);
                padding-bottom:0;
            }
        }
        @media screen and (max-width:450px){
            padding-top:rem(40px);
            .card{
                .tabs {
                    .nav {
                        li {
                            a{
                                max-width:100px;
                                text-align:center;
                                font-size:12px;
                                line-height:1.2;
                            }
                        }
                    }
                }
            }
        }
    }
    &__footer{
        max-width:150px;
        flex:0 0 150px;
        text-align:center;
        margin-top:rem(80px);
        position:relative;
        z-index:2;
        ul{
            @include flex(center , center);
            flex-direction:column;
            li{
                &:not(:last-child){
                    margin-bottom:rem(25px);
                }
                &.search{
                    svg{
                        width:22px;
                        height:auto;
                    }
                }
                &.lang{
                    a{
                        font-size:rem(20px);
                        font-weight:900;
                        color:var(--white);
                    }
                }
            }
        }
    }
    @media screen and (max-width:1600px){
        &__head{
            padding-bottom:rem(25px);
            &--wrapper{
                padding:0 35px 0 15px;
            }
        }
        &__sections{
            &--section{
                .imageWrapper{
                    .image{
                        width: 240px;
                        height: 135px;
                    }
                    .name{
                        font-size:rem(16px);
                    }
                }
            }
        }
    }
    @media screen and (max-width:991px){
        &__sections{
            &--section{
                .imageWrapper{
                    .image{
                       width: 150px;
                        height: 85px 
                    }
                    .name{
                        font-size:rem(14px);
                        top: 13%;
                        left:0;
                        max-width: 100%;
                        width:100%;
                        padding:0 8px;
                    }
                }
            }
        }
        &__head {
            .zain-logo{
                max-width: 115px;
                flex: 0 0 115px;
            }
        }
    }
    @media screen and (max-width:575px){
        &__head{
            &--wrapper{
                padding:0 20px 0 15px;
            }
        }
        &__sections{
            &--section{
                .imageWrapper{
                    .image{
                    width:150px;
                      margin:auto;
                    }
                }
            }
        }
    }
    @media screen and (max-width:370px){
        &__sections{
            &--section{
                .imageWrapper{
                    .image{
                        width:145px;
                        margin:auto;
                        .name{
                            padding:0 5px;
                            margin:0;
                            font-size:10px;
                        }
                    }
                }
            }
        }
    }
}

@media screen and (max-width:991px){
    .show-on-lg{
        display:flex !important;
    }
} 
.tableContents__sectionWrapper{
    scrollbar-color: #f0e81b #9b9c9e;
    scrollbar-width: thin;
    ::-webkit-scrollbar {
        width: 10px;
        height: 8px;
    }
    ::-webkit-scrollbar-track {
        background: #9b9c9e; 
    }
    ::-webkit-scrollbar-thumb {
        background: #f0e81b; 
        transition: 0.5s ease all;
    }
    ::-webkit-scrollbar-thumb:hover {
        background: #cfc904; 
    }
    * {
        scrollbar-width: thin;
        scrollbar-color: #cfc904 #9b9c9e;
    }
}
[lang="ar"]{
    .tableContents{
        &:after{
            transform:scaleX(-1);
        }
    .separator{
        margin: 0 13px 0 23px;
    }
    &:before{
        right:0;
        left:auto;
    }
    &__head{
        direction:rtl;
        .name{
            img{
                max-width:95px;
            }
        }
        &--wrapper{
            .extralinks{
                ul{
                    a{
                        span{
                            &.pdf-icon{
                                padding-left: rem(8px);
                                padding-right:0;
                            }
                            &.download-icon{
                                padding-right: rem(8px);
                                padding-left:0;
                            }
                            @media screen and (max-width:767px){
                                svg{
                                    max-width:20px;
                                }
                                &.pdf-icon{
                                    padding-left: rem(5px);
                                    padding-right:0;
                                }
                                &.download-icon{
                                    padding-right: rem(5px);
                                    padding-left:0;
                                }
                            }
                        }
                    }
                }
                @media screen and (max-width:1600px){
                    ul{
                        justify-content: center;
                        li{
                            &:not(:last-child){
                                margin-left:rem(25px);
                                margin-right:0;
                            }
                        }
                    }
                }
              
                @media screen and (max-width:575px){
                    ul{
                        justify-content: center;
                        li{
                            &:not(:last-child){
                                margin: 0 0 1.25rem 0;
                            }
                        }
                    }
                }
            }
        }
    }
    &__sections{
        &--row{
            flex-direction: row-reverse;
            padding-right:rem(50px);
            padding-left:0;
            >div{
                margin-left:rem(75px);
                margin-right:0;
                
            }
            @media screen and (max-width:1600px){
                >div{
                    margin-left:0;
                }
            }

            @media screen and (max-width:575px){
                padding-left:rem(16px);
                padding-right:0;
            }
        }
        &--section{
            .imageWrapper{
                .image{
                    margin-right: 0;
                    margin-left: auto;
                    &:after{
                        right:0;
                        left:auto;
                        top:0;
                    }
                }
                
                .name{
                    right:-40px;
                    left:auto;
                }
            }
        }
    }
    &__wrapper{
        // display: flex;
         position:relative;
        z-index:2;
        overflow-y: auto;
        padding:0 rem(30px);
        min-height: calc(100vh - 135px);
        .card{
            .card-body{
                padding-right: 4.0625rem;
                padding-left:0;
            }
            .tabs{
                flex-direction:row-reverse;
            }
        }
        @media screen and (max-width:1300px){
            .card{
                .card-body{
                    padding-right:rem(20px);
                    padding-left:0;
                }
            }
        }
        @media screen and (max-width:1199px){
            padding:0;
        }
        @media screen and (max-width:992px) and (min-width:768px){
            padding:0 45 0 0px;
        }
        @media screen and (max-width:991px){

            .card{
                .nav{
                    flex-direction: row-reverse !important;
                    padding: 0 0 0 20px;
                }
                .card-body{
                    padding:0;
                }
                .tabs{
                    .col-auto{
                        width:100%;
                    }
                }
            }
        }
        @media screen and (max-width:575px){
            padding-top: 2.5rem;
            .card{
                .tabs {
                    .nav {
                        padding-left:0;
                        padding-top: 1.875rem;
                    }
                }
            }
        }
    }
    &__footer{
        max-width:150px;
        flex:0 0 150px;
        text-align:center;
        margin-top:rem(80px);
        position:relative;
        z-index:2;
        ul{
            @include flex(center , center);
            flex-direction:column;
            li{
                &:not(:last-child){
                    margin-bottom:rem(25px);
                }
                &.search{
                    svg{
                        width:22px;
                        height:auto;
                    }
                }
                &.lang{
                    a{
                        font-size:rem(20px);
                        font-weight:900;
                        color:var(--white);
                    }
                }
            }
        }
    }
    @media screen and (max-width:1600px){
        &__head{
            &--wrapper{
                padding:0 15px 0 35px;
            }
        }
    }
    @media screen and (max-width:991px){
        &__sections{
            &--section{
                .imageWrapper{
                    .name{

                        right:0;
                        left:auto;
                    }
                }
            }
        }
    }
     @media screen and (max-width:575px){
         &__head{
            &--wrapper{
                padding:0 15px 0 20px;
            }
        }
        &__sections{
            &--section{
                .imageWrapper{
                    .image{
                        margin:auto;
                    }
                }
            }
        }
    }
    @media screen and (max-width:370px){
        &__sections{
            &--section{
                .imageWrapper{
                    .image{
                        width:145px;
                        margin:auto;
                        .name{
                            padding:0 5px;
                            margin:0;
                            font-size:10px;
                        }
                    }
                }
            }
        }
    }
}
}
</style>